import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.625 9.188a.376.376 0 0 1-.375.374.376.376 0 0 1-.375-.374V7.312c0-.206.169-.375.375-.375s.375.17.375.375zM5.25 0a3 3 0 0 1 3 3v1.5h.375c1.036 0 1.875.84 1.875 1.875v3.75C10.5 11.161 9.66 12 8.625 12h-6.75A1.875 1.875 0 0 1 0 10.125v-3.75C0 5.339.84 4.5 1.875 4.5h.375V3a3 3 0 0 1 3-3m0 .75A2.237 2.237 0 0 0 3 3v1.5h4.5V3A2.25 2.25 0 0 0 5.25.75m-3.375 4.5C1.254 5.25.75 5.754.75 6.375v3.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.504 1.125-1.125v-3.75c0-.621-.504-1.125-1.125-1.125z"
    }, null, -1)
  ])))
}
export default { render: render }